import { LocationsModel } from "./interfaces";

import { request } from "api/actions";
import { AxiosRequestConfig } from "axios";
import types from "./types";

export const locationsCreate = (
    applicationKey: string,
    data: LocationsModel,
    onResponse?: Function,
) =>
    request(
        types.STORE_REQUEST,
        types.STORE_FAILED,
        types.STORE_SUCCESS,
        "locationsCreate",
        {
            config: {
                params: { _app: applicationKey },
            },
            data,
        },
        onResponse,
        undefined,
        "event",
    );

export const locationsDelete = (
    applicationKey: string,
    id: number,
    onResponse?: Function,
) =>
    request(
        types.DESTROY_REQUEST,
        types.DESTROY_FAILED,
        types.DESTROY_SUCCESS,
        "locationsDelete",
        {
            config: {
                params: { _app: applicationKey },
            },
            url: {
                id,
            },
        },
        onResponse,
        undefined,
        "event",
    );

export const locationsFetch = (config?: AxiosRequestConfig) =>
    request(
        types.FETCH_REQUEST,
        types.FETCH_FAILED,
        types.FETCH_SUCCESS,
        "locationsFetch",
        {
            config,
        },
        undefined,
        undefined,
        "event",
    );

export const locationsGet = (
    applicationKey: string,
    id: number,
    config?: AxiosRequestConfig,
    onResponse?: Function,
) =>
    request(
        types.GET_REQUEST,
        types.GET_FAILED,
        types.GET_SUCCESS,
        "locationsGet",
        {
            config: {
                ...config,
                params: { _app: applicationKey, ...config?.params },
            },
            url: {
                id,
            },
        },
        onResponse,
        undefined,
        "event",
    );

export const locationsPatch = (
    applicationKey: string,
    id: number,
    data: any,
    onResponse?: Function,
) => {
    return request(
        types.PATCH_REQUEST,
        types.PATCH_FAILED,
        types.PATCH_SUCCESS,
        "locationsPatch",
        {
            config: {
                params: { _app: applicationKey },
            },
            data,
            url: { id },
        },
        onResponse,
        undefined,
        "event",
    );
};

export const locationsTableUpdate = (action: string, data: any) => ({
    type: types.TABLE_UPDATE,
    action,
    data,
});

export const locationsUpdate = (
    applicationKey: string,
    id: number,
    data: any,
    onResponse?: Function,
) => {
    return request(
        types.UPDATE_REQUEST,
        types.UPDATE_FAILED,
        types.UPDATE_SUCCESS,
        "locationsUpdate",
        {
            config: {
                params: { _app: applicationKey },
            },
            data,
            url: { id },
        },
        onResponse,
        undefined,
        "event",
    );
};
